module.exports = __webpack_public_path__ + "static/media/volunteersSelected.37a512bf.svg";